import { useEffect, useState } from "react";
import { getOfficers } from "./officersApi";

const cache = new Map<string, string>();
const inflight = new Map<string, Promise<void>>();

function userToName(u: {
  firstName?: string;
  lastName?: string;
  email?: string;
}): string {
  const full = [u.firstName, u.lastName].filter(Boolean).join(" ").trim();
  return full || u.email || "";
}

async function loadStation(stationId: string): Promise<void> {
  if (inflight.has(stationId)) return inflight.get(stationId);
  const promise = (async () => {
    const res = await getOfficers(stationId);
    for (const u of res.users) {
      const name = userToName(u);
      if (name) cache.set(u.id, name);
    }
  })().catch(() => {
    // Swallow — name resolution is non-critical, fallback to userId.
  });
  inflight.set(stationId, promise);
  return promise;
}

export function getUserName(userId: string): string | undefined {
  return cache.get(userId);
}

export function useUserDirectory(stationId: string | undefined): {
  resolveName: (userId: string) => string | undefined;
  ready: boolean;
} {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!stationId) return;
    let cancelled = false;
    loadStation(stationId).finally(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, [stationId]);

  return {
    resolveName: (userId: string) => cache.get(userId),
    ready,
  };
}
